<template>
  <div v-if="detail" style="min-width:800px;width:60%">
     <el-descriptions title="业务详情">
       <template v-slot:title>
         <span>业务详情</span>
         <svg
          class="icon"
          aria-hidden="true"
          font-size="20px"
          v-if="detail.urgentIcon"
        >
          <use :xlink:href="'#' + detail.urgentIcon" />
        </svg>
       </template>
      <el-descriptions-item :label="item.fieldName + '：'" v-for="(item, index) in columnAllData" :key="index">
        <template v-if="item.fieldKey === 'repairTimes'">
          {{ detail[item.fieldKey] || 0}}
        </template>
        <template v-else>
          {{ detail[item.fieldKey] }}
        </template>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions >
      <el-descriptions-item label="外观图片：" >
        <template v-if="detail.appearancePictures && detail.appearancePictures.length">
          <ZUpload @changed="handlePictures" :value="detail.appearancePictures || []" :option="{ config: {} }" :canUpload="false"/>
        </template>
        <template v-else>
          无
        </template>
      </el-descriptions-item>
    </el-descriptions>

    <div class="dataForm" >
      <el-form
        ref="dataForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="mb-20"
      >
        <el-form-item label="是否完成" prop="complete" v-if="detail.repairType !== 1">
         <el-switch v-model="ruleForm.complete" />
        </el-form-item>
        <template v-if="detail.type === 2">
          <el-form-item label="产品说明书" prop="productDes" >
            <ZUpload @changed="handleUploadChange($event, 'productDes')" :value="ruleForm.productDes" :option="{ config: {} }"/>
            <!-- <el-input v-model="ruleForm.productDes" type="textarea"  clearable></el-input> -->
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="检测情况" prop="checkDes">
            <el-input v-model="ruleForm.checkDes" type="textarea" clearable></el-input>
          </el-form-item>
          <el-form-item label="更换配件" prop="changeParts">
            <el-input v-model="ruleForm.changeParts" type="textarea" clearable></el-input>
          </el-form-item>
          <el-form-item label="检查图片" prop="checkPictures">
            <ZUpload @changed="handleUploadChange($event, 'checkPictures')" :value="ruleForm.checkPictures" :option="{ config: {} }"/>
          </el-form-item>
        </template>
      </el-form>
      <div class="dialog-footer mt-20" >
        <el-button @click="cancle" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit"
        >
          {{ t("table.confirm") }}
        </el-button>
      </div>
     </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, nextTick, unref, onMounted } from 'vue'
import { ElMessage, ElForm } from 'element-plus'
import { updateRepair } from '@/apis/Repair'
import ZUpload from '@/components/common/ZUpload.vue'
import { useI18n } from 'vue-i18n'
import { TableField } from './RepairTable'

export default defineComponent({
  name: 'RepairForm',
  components: {
    ZUpload
  },
  props: {
    id: { type: Number, required: true, default: 0 },
    dialogFormVisible: { type: Boolean, required: true },
    api: { type: String, required: true },
    detail: { type: Object, default: () => null, required: true }
  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()
    const dataForm = ref(ElForm)

    const dataMap = reactive({
      submitLoading: false,
      detail: props.detail,
      columnAllData: TableField,
      ruleForm: {
        complete: '',
        checkDes: '',
        changeParts: '',
        productDes: [],
        checkPictures: []
      },
      rules: {
        complete: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        checkDes: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        changeParts: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        productDes: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        checkPictures: [{ required: false, message: '请填写必填项', trigger: 'change' }]
      },
      handleUploadChange(val: any, fieldKey: any) {
        dataMap.ruleForm[fieldKey] = val || []
      },
      handlePictures(val: any) {
        dataMap.detail.appearancePictures = val || []
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const tempData = dataMap.ruleForm

              await updateRepair(props.id, { ...tempData, complete: Boolean(tempData.complete), productDes: tempData.productDes.join(',') } as any)
              dataMap.submitLoading = false
              context.emit('update:visibel')
              context.emit('submit')
              ElMessage({
                message: '保存成功',
                type: 'success',
                duration: 2000
              })
            } catch (err:any) {
              console.log(err, 'err')
              dataMap.submitLoading = false
              if (err && err.errors) {
                err.errors.forEach((item: any) => {
                  const field = dataMap.rules[item.field][0]
                  if (field) {
                    field.message = null
                    nextTick(() => {
                      field.message = item.defaultMessage
                    })
                  }
                })
              }
            }
          }
        })
      }
    })
    onMounted(() => {
      if (props.detail) {
        dataMap.ruleForm = {
          complete: props.detail.complete,
          checkDes: props.detail.checkDes,
          changeParts: props.detail.changeParts,
          productDes: props.detail.productDes ? props.detail.productDes.split(',') : [],
          checkPictures: props.detail.checkPictures || []
        }
      }
    })
    return { t, ...toRefs(dataMap), dataForm }
  }

})
</script>
<style lang="scss" scoped>
.el-descriptions{
  padding-left: 30px;
}
.dataForm{
  margin-left: 0;
  margin-top: 20px;
}
</style>
